import {getCompId} from '../env/compId';
import {getArtifactsVersions} from '../env/getWindowVersion/getWindowVersion';
import {getPlayerVersion} from '../env/playerVersion';
import {getSessionId} from '../env/sessionId';
import {getSiteOwnerId} from '../env/siteOwnerId';
import {getVisitorId} from '../env/visitorId';
import {BI_SCHEMA} from './biEvents';
import {initLogger} from './biLogger';

export function createMusicLogger(albumId) {
  return initLogger({
    compId: getCompId(),
    playerVersion: getPlayerVersion(),
    sessionId: getSessionId(),
    artifactVersion: getArtifactsVersions(),
    albumId,
    isOwner: getVisitorId() === getSiteOwnerId(),
    schema: BI_SCHEMA,
  });
}
